var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInsta(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "insta",
    transform: "translate(-1522 -12309)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6846",
    "data-name": "Rectangle 6846",
    width: 32,
    height: 32,
    rx: 5,
    transform: "translate(1522 12309)",
    fill: "#02a2ac"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_simple-instagram",
    "data-name": "Icon simple-instagram",
    d: "M9,0C6.555,0,6.25.011,5.29.054A6.636,6.636,0,0,0,3.1.472,4.407,4.407,0,0,0,1.51,1.51,4.391,4.391,0,0,0,.472,3.1,6.617,6.617,0,0,0,.054,5.29C.009,6.25,0,6.555,0,9s.011,2.75.054,3.71a6.64,6.64,0,0,0,.418,2.185A4.414,4.414,0,0,0,1.51,16.489,4.4,4.4,0,0,0,3.1,17.527a6.645,6.645,0,0,0,2.185.418C6.25,17.991,6.555,18,9,18s2.75-.011,3.71-.054a6.66,6.66,0,0,0,2.185-.418,4.6,4.6,0,0,0,2.632-2.632,6.64,6.64,0,0,0,.418-2.185C17.991,11.75,18,11.445,18,9s-.011-2.75-.054-3.71A6.656,6.656,0,0,0,17.527,3.1,4.417,4.417,0,0,0,16.489,1.51,4.385,4.385,0,0,0,14.895.472,6.621,6.621,0,0,0,12.71.054C11.75.009,11.445,0,9,0ZM9,1.62c2.4,0,2.689.012,3.637.053a4.959,4.959,0,0,1,1.67.311,2.962,2.962,0,0,1,1.708,1.708,4.969,4.969,0,0,1,.31,1.67c.043.949.053,1.234.053,3.637s-.011,2.689-.056,3.637a5.065,5.065,0,0,1-.316,1.67,2.858,2.858,0,0,1-.674,1.036,2.808,2.808,0,0,1-1.035.672,5.006,5.006,0,0,1-1.676.31c-.955.043-1.237.053-3.644.053s-2.689-.011-3.644-.056a5.1,5.1,0,0,1-1.677-.316,2.787,2.787,0,0,1-1.034-.674A2.733,2.733,0,0,1,1.947,14.3a5.108,5.108,0,0,1-.315-1.676c-.034-.945-.046-1.237-.046-3.633S1.6,6.3,1.632,5.343a5.1,5.1,0,0,1,.315-1.675,2.668,2.668,0,0,1,.675-1.036,2.662,2.662,0,0,1,1.034-.673,4.981,4.981,0,0,1,1.666-.316C6.278,1.609,6.559,1.6,8.966,1.6L9,1.62ZM9,4.378A4.621,4.621,0,1,0,13.621,9,4.621,4.621,0,0,0,9,4.378ZM9,12a3,3,0,1,1,3-3A3,3,0,0,1,9,12Zm5.884-7.8A1.08,1.08,0,1,1,13.8,3.117,1.081,1.081,0,0,1,14.884,4.2Z",
    transform: "translate(1529 12316)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInsta);
export default __webpack_public_path__ + "static/media/insta.24369b3c95284bb164bb8bd6d903c33e.svg";
export { ForwardRef as ReactComponent };